import { GetAccountQuery } from "../../../../types/graphql-schema";
import PersonalIntegrationDetailPage from "./personal-integration-detail-page";

type Account = NonNullable<GetAccountQuery["me"]>;

const IntegrationDetailDialog = ({
  account,
  slug,
  open,
  onClose,
}: {
  account: Account;
  slug: string;
  open: boolean;
  onClose: () => void;
}) => {
  if (!slug) {
    return null;
  }
  return (
    <PersonalIntegrationDetailPage
      account={account}
      slug={slug}
      open={open}
      onClose={onClose}
    />
  );
};

export default IntegrationDetailDialog;
